<div class="container" id="BOMDataPrint" style="background-color: white; height: 100%; overflow: hidden; margin: 0px; padding: 0px; width: 100%;">
    <div style="width: 100%; font-family: Calibri;">
        <span style="text-align: center; margin: 10px; margin-bottom: 0;font-size: 30px;"><h2 class="headerLblcontent" style="font-weight: bold;">Bill of Materials </h2></span>
        <!--Header-->
        <div class="row col-md-12" style="margin: 3px; padding-right: 20px;">
            <div style="text-align:left; display: flex; flex-direction: column; justify-content: start; width: 50%;">
                <div>
                    <span class="lableCls">Product : </span><span class="fontstyle">{{prductData.productName}}</span>
                </div>
                <div *ngIf="prtCnfg.totalPrice && isRateView">
                    <span class="lableCls">Total Cost : </span><span class="fontstyle">₹ {{totalCost | lacFormat}}</span>
                </div>
            </div>
            <div style="text-align: right; display: flex; flex-direction: column; justify-content: start; width: 50%;">
                <div>
                    <span class="lableCls">Code : </span><span class="fontstyle">{{prductData.productCode}}</span> 
                </div>
            </div>
        </div>
            <!-- product details -->
            <div class="col-md-12 col-sm-12 col-xs-12 pad0 webView" style="margin-top: 20px;">
                <table class="table table-bordered">
                    <thead>
                        <tr style="text-align: left;">
                            <th style="width: 8%;">Material Item</th>
                            <th style="width: 4%;">Code</th>
                            <th *ngIf="prtCnfg.rates && isRateView" style="width: 2%; text-align: right;">Rate (₹)</th>
                            <th style="width: 1%; min-width: 110px; text-align: right;">Required Qty</th>
                            <th style="width: 1%;">Unit</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style="vertical-align: top;" *ngFor="let p of prductData.bom;">
                            <td style="vertical-align: top;">
                                <span>{{p.ItemName}}</span>
                            </td>
                            <td style="vertical-align: top;">
                                <span>{{p.ItemCode}}</span>
                            </td>
                            <td *ngIf="prtCnfg.rates && isRateView" style="text-align: right; vertical-align: top;">
                                <span>{{p.DefPurchRate | lacFormat}}</span>
                            </td>
                            <td style="text-align: right; vertical-align: top;">
                                <span>{{p.Qty}}</span>
                            </td>
                            <td style="vertical-align: top;">
                                <span>{{p.Unt}}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
      </div>
</div>
